import { KAYNAKCI_STANDARTLARI } from "./kutuk-belge.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). Kütük türü `wpq` ile karışmasın diye ayrı ad; iki cins (WPQ, süreklilik kaydı) tek türdür. */
export const WPQ_BELGE_TURU = "kaynakci_wpq";
/** Okunan Documents türleri (GELEN_TURLERI anahtarları; Registers grubu, kişisel sınıf). */
export const WPQ_GELEN_TURU = "kutuk:kaynakci:wpq";
export const SUREKLILIK_GELEN_TURU = "kutuk:kaynakci:sureklilik";
export const wpqGelenTuruMu = (t) => t === WPQ_GELEN_TURU || t === SUREKLILIK_GELEN_TURU;
export const wpqCinsi = (t) => (t === WPQ_GELEN_TURU ? "wpq" : t === SUREKLILIK_GELEN_TURU ? "sureklilik" : null);
/** Olay kaydında nesne tipi (nesneId = wpq_kaydi.id). */
export const WPQ_OLAY_NESNESI = "wpq_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const WPQ_GIRDI_AILESI = "Welder-document-input";
/** DOCUMENT sayfasındaki "Document type" değerleri. */
export const WPQ_EXCEL_ADI = "Welder qualification";
export const SUREKLILIK_EXCEL_ADI = "Welder continuity record";
/** Bir belgede en çok yeterlilik ve süreklilik satırı (`Row`). */
export const WPQ_YETERLILIK_EN_COK = 6;
export const WPQ_SUREKLILIK_EN_COK = 12;
/** Okuma işi kodu ("WPQR-5A1B2C3D"); "WPQ-" uyarı kodlarından ayrı. */
export const wpqKodu = (kayitId) => `WPQR-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** WPQ belge düzeyi alanlar (DOCUMENT; sabit sıra; sözleşme §8.3, sürüm 1). `etiket` hem ekran metni hem DOCUMENT'teki Field adıdır. */
export const WPQ_ALANLARI = [
    { alan: "kaynakci_kodu", etiket: "Welder code", kimlik: false }, { alan: "kaynakci_adi", etiket: "Welder name", kimlik: false },
    { alan: "standart", etiket: "Standard", kimlik: false }, { alan: "test_tarihi", etiket: "Test date", kimlik: false },
    { alan: "gecerlilik_sonu", etiket: "Valid until", kimlik: false },
];
/** Süreklilik kaydının belge düzeyi alanları (DOCUMENT; sözleşme §8.3). */
export const SUREKLILIK_BELGE_ALANLARI = [
    { alan: "kaynakci_kodu", etiket: "Welder code", kimlik: false }, { alan: "kaynakci_adi", etiket: "Welder name", kimlik: false },
];
/** Yeterlilik satırı alanları (ROWS `Table = Qualification`, satır başına 3; yalnız WPQ'da). */
export const WPQ_YETERLILIK_ALANLARI = [
    { alan: "proses", etiket: "Process", kimlik: false }, { alan: "wps", etiket: "WPS", kimlik: false }, { alan: "bitis", etiket: "Valid until", kimlik: false },
];
/** Süreklilik satırı alanları (ROWS `Table = Continuity`, satır başına 2). İmzadan yalnız varlığı okunur ("Signed" / "Not signed"). */
export const WPQ_SUREKLILIK_ALANLARI = [
    { alan: "tarih", etiket: "Date", kimlik: false }, { alan: "imza", etiket: "Signature", kimlik: false },
];
/** Alanın ekran adı (bütün listelerde aranır); bilinmiyorsa alanın kendisi. */
export const wpqEtiketi = (alan) => [...WPQ_ALANLARI, ...WPQ_YETERLILIK_ALANLARI, ...WPQ_SUREKLILIK_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır; `Table` iki tablodan biri). */
export const WPQ_SATIR_BASLIKLARI = ["Table", "Row", "Field", "Value", "As written", "Page", "Certainty"];
export const WPQ_TABLOLARI = { yeterlilik: "Qualification", sureklilik: "Continuity" };
/** `Signature` hücresinin yalnız iki değeri. */
export const IMZA_DEGERLERI = { imzali: "Signed", imzasiz: "Not signed" };
/** Kişinin "Add to Registers" onayının alanı (`belge_deger_onayi.alan`; parça 1, satır başına bir kez). */
export const SUREKLILIK_SATIRI_ALANI = (sira) => `sureklilik_satiri:${sira}`;
/** Kaynakçı kodunun karşılaştırma anahtarı: kırpılır, büyük harf, bütün boşluklar atılır (tire korunur); boşsa "". */
export const kaynakciKoduSade = (v) => (v ?? "").trim().toUpperCase().replace(/\s+/g, "");
/**
 * Belgedeki standart yazısı → Registers standardı (`KAYNAKCI_STANDARTLARI`): "9606" geçerse EN ISO 9606-1; "QW-484" ya da "ASME" geçer ve QW-484B değilse
 * ASME IX QW-484. Öteki her yazım (ISO 14732 ve QW-484B dahil) ve boş değer null: kişi elle seçer.
 */
export function kaynakciStandartOku(v) {
    const s = (v ?? "").trim().toUpperCase();
    if (!s)
        return null;
    if (/9606/.test(s))
        return KAYNAKCI_STANDARTLARI[1];
    if (/QW[\s-]*484\s*B/.test(s))
        return null;
    if (/QW[\s-]*484|ASME/.test(s))
        return KAYNAKCI_STANDARTLARI[0];
    return null;
}
/** WPS kodunun karşılaştırma anahtarı: büyük harf, sondaki revizyon ("REV 2", "Rev.A", "REVISION 1") atılır, boşluklar atılır. */
export const wpsSade = (v) => (v ?? "").trim().toUpperCase().replace(/\s*REV(ISION)?\.?\s*[A-Z0-9]+$/, "").replace(/\s+/g, "");
/** `Signature` değeri: yalnız tam "Signed" / "Not signed" (büyük-küçük harfe duyarsız); öteki her yazım null. */
export function imzaOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    if (s === IMZA_DEGERLERI.imzali.toLowerCase())
        return "imzali";
    if (s === IMZA_DEGERLERI.imzasiz.toLowerCase())
        return "imzasiz";
    return null;
}
/** ISO 4063 numaraları ve AWS kısaltmaları (standart adlardır, değer kararı değildir). OASIS yalnız üç prosesi bilir. */
const PROSES_ADLARI = {
    TIG: ["TIG", "GTAW", "141", "142", "143", "145"],
    SMAW: ["SMAW", "MMA", "MMAW", "111"],
    SAW: ["SAW", "12", "121", "122", "123", "124", "125"],
};
/** Proses yazısı → OASIS prosesleri ve tanınmayan parçalar ("GTAW/SMAW" → TIG, SMAW; "135" → bilinmeyen). Tanınmayan yazımda WPQ-03 proses kısmı susar. */
export function kaynakProsesleri(v) {
    const prosesler = [];
    const bilinmeyen = [];
    for (const p of (v ?? "").toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean)) {
        const pr = Object.keys(PROSES_ADLARI).find((k) => PROSES_ADLARI[k].includes(p));
        if (pr) {
            if (!prosesler.includes(pr))
                prosesler.push(pr);
        }
        else if (!bilinmeyen.includes(p))
            bilinmeyen.push(p);
    }
    return { prosesler, bilinmeyen };
}
const kesinDeger = (l, alan) => {
    const d = l.find((x) => x.alan === alan);
    return d && d.kesinlik === "kesin" && d.deger !== null && d.deger.trim() ? d.deger.trim() : null;
};
/** Yeterlilik satırlarından kaynakçının yeterliliği (yalnız kesin değerler). `prosesBilinir`: en az bir kesin proses var ve hiçbirinde tanınmayan parça yok. */
export function kaynakciYeterliligiKur(satirlar) {
    const prosesler = [];
    const wpsler = [];
    let kesinProses = 0;
    let bilinmeyenVar = false;
    for (const s of satirlar) {
        const p = kesinDeger(s.degerler, "proses");
        if (p) {
            kesinProses++;
            const k = kaynakProsesleri(p);
            if (k.bilinmeyen.length)
                bilinmeyenVar = true;
            for (const x of k.prosesler)
                if (!prosesler.includes(x))
                    prosesler.push(x);
        }
        const w = wpsSade(kesinDeger(s.degerler, "wps"));
        if (w && !wpsler.includes(w))
            wpsler.push(w);
    }
    return { prosesler, prosesBilinir: kesinProses > 0 && !bilinmeyenVar, wpsler, satir: satirlar.length };
}
/* ---------------- uyarılar ---------------- */
/** Kartta üretilen kodlar (üretim sırası: sarı, sarı, sarı, gri, gri). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). WPQ-03 weld map'te üretilir. */
export const WPQ_UYARI_KODLARI = ["WPQ-02", "GEN-13", "WPQ-05", "WPQ-04", "GEN-12"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). */
export const WPQ_UYARI_KALIPLARI = {
    "WPQ-02": "Continuity date passed without a signed record: {0}, {1}.",
    "GEN-13": "No signature in continuity row {0} ({1}).",
    "WPQ-05": "WPS on the qualification is not in Registers: {0}.",
    "WPQ-04": "Several qualifications. End dates shown per process.",
    "GEN-12": "Older than the filed qualification of {0}. The register date stays.",
};
//# sourceMappingURL=wpq.js.map